export default (numberToFormat, digit = 0) => {
  const prefix = numberToFormat < 0 ? '-' : '';
  digit = digit < 0 ? 0 : digit;
  numberToFormat = Math.abs(numberToFormat);

  if (numberToFormat === 0) {
    return 0;
  }

  if (numberToFormat < 1000) {
    if (numberToFormat % 1 !== 0 && (numberToFormat * 10) % 1 === 0) {
      return `${numberToFormat}0`;
    }

    return numberToFormat;
  }

  const abbrv = ['k', 'M', 'B', 'T', 'P', 'E'];
  const power = Math.floor(Math.log10(numberToFormat) / 3);

  // if ((numberToFormat / Math.pow(1000, power)).toFixed(digit).slice(-1) === '0') {
  //   return prefix + (numberToFormat / Math.pow(1000, power)).toFixed(digit - 1) + abbrv[power - 1];
  // }

  return prefix + (numberToFormat / Math.pow(1000, power)).toFixed(digit) + abbrv[power - 1];
};
